// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uqE5k","content":"styles_content__1BsGW"};